import { makeStyles } from "@material-ui/core/styles";

export const WatchlistHandlerStyles = makeStyles(theme => ({
  padding: {
    cursor: "pointer",
    margin: "0px",
  },
  icon: { paddingRight: "8px" },
}));
